import React, { useEffect } from 'react';
import img from "../images/404.webp";
function Notfound() {
    useEffect(() =>{
        setTimeout(function() {
            window.location.replace('/');
          }, 5000);
    },[])
  return (
    <div className='notfound'>
        <img src={img} alt="" />
        <h6>wait 5 seconds. page will redirect</h6>
    </div>
  )
}

export default Notfound